/**
 * Stores the search params in local storage
 * @param queryStringData
 */
export function storeQueryString(queryStringData) {
    try {
        Object.keys(queryStringData).forEach((key) => {
            if (!shouldStoreSearchKey(key)) {
                return;
            }

            localStorage.setItem(`search-${key}`, queryStringData[key]);
        });
    } catch (e) {
        // TODO: Find better way to store this
    }
}

/**
 * Retrieves the search params from local storage
 * @returns {Object}
 */
export function retrieveQueryString() {
    let searchData = {};
    try {
        Object.keys(window.localStorage).forEach((key) => {
            const strippedKey = key.replace('search-', '');

            if (!shouldStoreSearchKey(strippedKey)) {
                // remove the key from the localstorage if it already exists
                localStorage.removeItem(key);
                return;
            }

            searchData[strippedKey] = localStorage.getItem(key);
        });
    } catch (e) {
        // TODO: Find better way to store this
    }

    return searchData;
}

/**
 * Checks if the key should be stored in the localstorage (such as search filters)
 * @param key
 * @returns {boolean}
 */
function shouldStoreSearchKey(key) {
    return !['type', 'space_size', 'features'].includes(key);
}
